<template>
    <dash
        icon="fa fa-truck"
        titulo="ENTREGAS SGF"
        subTitulo="GESTOR"
        @click.native="$router.push({ name: 'Gestores_Entregas' })"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>
